// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__G_Ic5","row":"Node_row__1RlGg","label":"Node_label__1VzfV","footer":"Node_footer__E_DLk"};